<template>
    <Fragment>
        <!-- Modal -->
        <div class="modal menu_catalog" :id="modalId" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">

                        <h5 class="modal-title title" id="modal-mobile-menu-title">{{ title }}</h5>
                        <button type="button" 
                            class="btn btn_lg btn_common btn_icononly" 
                            data-dismiss="modal"
                            :id="modalId + 'Close'"
                        ><i class="f7-icons icon_lg">xmark</i></button>

                    </div>
                    <div class="modal-body">                        

                        <div class="catalog_gallery change_catalog">
                            <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xxl-4">

                                <template v-for="(item, index) in items">
                                
                                    <!-- item -->
                                    <div class="col catalog_gallery_item">

                                        <div v-if="item.is_new" class="cg_i item_icon item_icon_topleft">
                                            <img src="/i/new.svg" alt="Новинка">
                                        </div>
                                        
                                        <div v-if="item.is_bestseller" class="cg_i item_icon item_icon_topleft">
                                            <img src="/i/hit.svg" alt="Новинка">
                                        </div>
                                        
                                        <div v-if="item.is_sale" class="cg_i item_icon item_icon_topleft">
                                            <img src="/i/sale.svg" alt="Новинка">
                                        </div>
                                        
                                        <div class="cg_p">
                                            <a :href="'/catalog/item/' + item.slug">
                                                <div v-if="item.images && item.images.length" class="item_picture">
                                                    <ins v-if="item.images.length > 1" :style="'background-image: url(' + (item.images[1].thumb_path ? item.images[1].thumb_path : item.images[1].path) + ')'">
                                                        <div :style="'background-image: url(' + (item.images[0].thumb_path ? item.images[0].thumb_path : item.images[0].path) + ')'"></div>
                                                    </ins>
                                                    <div v-else :style="'background-image: url(' + (item.images[0].thumb_path ? item.images[0].thumb_path : item.images[0].path) + ')'"></div>
                                                </div>
                                                <div v-else class="item_picture item_picture_no-image">
                                                    <div class="no-image"></div>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="cg_name">
                                            <a :href="'/catalog/item/' + item.slug" class="text_line_cut">
                                                {{ item[titleAttr] }}
                                            </a>
                                        </div>
                                        <div class="cg_action">
                                            <div class="cg_actions_btns float-right">
                                                <button @click.prevent="click(item)" class="btn btn_lg btn_common btn_icontext"><i
                                                        class="f7-icons icon_lg">checkmark_alt_circle</i>Выбрать</button>
                                            </div>
                                            <div class="cg_price price_sm">{{ item.price_for_one }} р.</div>
                                            <div class="cg_box item_box">Мин. {{ item.qty_per_pack }} {{ item.unit }}</div>
                                        </div>
                                        <div class="popover catalog_popover bs-popover-bottom" role="tooltip">
                                            <div class="arrow"></div>
                                            <div class="popover-header"></div>
                                            <div class="popover-body">
                                                <div class="cg_info item_info">
                                                    <p v-if="item.sku"><span>Артикул</span> {{ item.sku }}</p>
                                                    <p v-if="item.attr_color"><span>Цвет</span> {{ item.attr_color }}</p>
                                                    <p v-if="item.attr_size"><span>Размер</span> {{ item.attr_size }}</p>
                                                    <p v-if="item.attr_material"><span>Материал</span> {{ item.attr_material }}</p>
                                                    <p v-if="item.attr_type"><span>Тип</span> {{ item.attr_type }}</p>
                                                    <p v-if="item.country"><span>Производитель</span> {{ item.country }}</p>
                                                    <p v-if="item.attr_other"><span>Прочее</span> {{ item.attr_other }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /item -->

                                </template>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </Fragment>
</template>


<script>
import { Fragment } from "vue-fragment";

export default {
    props: {
        modalId: String,
        title: String,
        items: Array,
        titleAttr: String,
    },

    components: { Fragment },

    data: function () {
        return {
        };
    },

    methods: {
        click: function (item) {
            console.log('click', item);
            this.$emit('click:item', item);
            
            document.getElementById(this.modalId + 'Close').click();
        },
    },
    computed: {
    },
    mounted() {
    }
};
</script>
